import { defineMessages } from '@jutro/locale';

export default defineMessages({
    claims: {
        id: 'gateway.views.claimSummary.Claims',
        defaultMessage: 'Claims'
    },
    claimX: {
        id: 'gateway.views.claimSummary.CLAIM#',
        defaultMessage: 'CLAIM#'
    },
    lossDate: {
        id: 'gateway.views.claimSummary.LOSS DATE',
        defaultMessage: 'LOSS DATE'
    },
    lossType: {
        id: 'gateway.views.claimSummary.LOSS TYPE',
        defaultMessage: 'LOSS TYPE'
    },
    descriptiion: {
        id: 'gateway.views.claimSummary.DESCRIPTION',
        defaultMessage: 'DESCRIPTION'
    },
    status: {
        id: 'gateway.views.claimSummary.STATUS',
        defaultMessage: 'STATUS'
    },
    noClaimsResult: {
        id: 'gateway.views.claimSummary.There are no claims',
        defaultMessage: 'There are no claims'
    },
    policy: {
        id: 'gateway.views.claimSummary.Policy',
        defaultMessage: '{lob} Policy'
    },
    policyX: {
        id: 'gateway.views.claimSummary.PolicyX',
        defaultMessage: '#{policyNumber}'
    },
    vehicleDescription: {
        id: 'gateway.views.claimSummary.YearMakeModel',
        defaultMessage: '{year}, {make}, {model} {trim}'
    },
    locationDescription: {
        id: 'gateway.views.claimSummary.locationDesc',
        defaultMessage: '{addressLine1}, {city}, {state} {zip}'
    },
    claimDetail: {
        id: 'gateway.views.claimSummary.claimDetail',
        defaultMessage: 'Claim Detail'
    },
    closeBtn: {
        id: 'gateway.views.claimSummary.claimDetailPopup.Close',
        defaultMessage: 'Close'
    },
    popupBody: {
        id: 'gateway.views.claimSummary.claimDetailPopup.Close',
        // eslint-disable-next-line max-len
        defaultMessage: 'Umbrella claim status is unavailable through this system. Please contact our Claims Call Center at (800) 854-6011 for Umbrella'
    }
});